// @flow
import type {Action} from '../actions/modals';

export type State = {
    GUESTS: {
        isOpen: boolean
    },
    DATES: {
        isOpen: boolean
    },
    SEARCH: {
        isOpen: boolean
    },
    FILTERS: {
        isOpen: boolean
    },
    FILTERS_DATES: {
        isOpen: boolean
    },
    FILTERS_GUEST: {
        isOpen: boolean
    }
};

const initialState: State = {
    GUESTS: {
        isOpen: false
    },
    DATES: {
        isOpen: false
    },
    SEARCH: {
        isOpen: false
    },
    FILTERS: {
        isOpen: false
    },
    FILTERS_DATES: {
        isOpen: false
    },
    FILTERS_GUEST: {
        isOpen: false
    }
};

export default function reducer(
    state: State = initialState,
    action: Action
): State {
    if (action.type === 'MODAL/TOGGLE') {
        return {
            ...state,
            [action.payload.modalName]: {
                isOpen: action.payload.isOpen
            }
        };
    }
    return state;
}
